<template>
  <div>
    <div class="filter-header">
      {{ filtername }} <small v-show="filtername === 'Section'">(beta)</small>
      <b-badge
        v-if="['indication', 'therapeutic-area'].indexOf(filterid) >= 0"
        v-b-tooltip.hover
        class="ml-3"
        title="Please note that the associated medical conditions and related therapeutic areas are based on automated data extractions that have not been manually validated. Validation is in progress."
        variant="warning"
        >Disclaimer</b-badge
      >
      <b-button
        v-show="showApply"
        size="sm"
        variant="primary"
        class="float-right mr-3 mb-1"
        @click="emitApplySelections"
      >
        Apply
      </b-button>
    </div>
    <div class="ml-2">
      <b-form-input
        v-if="search"
        :id="'filter-search-' + filterid"
        v-model="searchTerm"
        class="filter-search mt-2 mb-1"
        size="sm"
        placeholder="Search"
        trim
      ></b-form-input>
      <a
        v-show="filteredOptions.length > 0 && filteredOptions.length <= 100"
        :id="'filter-select-all-' + filterid"
        class="select-all-options"
        @click="selectAllOptions()"
        >Select All
      </a>
      <a
        v-show="dataSelected.length > 0 && filteredOptions.length > 0"
        :id="'filter-clear-all-' + filterid"
        class="clear-all-options ml-2"
        @click="clearAllOptions()"
        >Clear All</a
      >
      <span
        v-show="filteredOptions.length === 0"
        :id="'filter-no-match-' + filterid"
        >No matching options.</span
      >
    </div>
    <b-form-group
      v-if="filteredOptions.length > 0"
      class="checkbox-filter ml-2"
    >
      <b-form-checkbox
        v-for="option in topOptions"
        :key="option.key"
        v-model="dataSelected"
        name="checkbox"
        :class="'filter-option-' + filterid"
        :value="option.key"
        :options="topOptions"
        :checked="dataSelected"
        @change="showApply = true"
      >
        {{ option.key }} &nbsp;&nbsp;
        <b-badge variant="light">
          <span v-if="option.reverseNestedAgg">
            {{ option.reverseNestedAgg.doc_count.toLocaleString() }}
          </span>
          <span v-else>
            {{ option.doc_count.toLocaleString() }}
          </span>
        </b-badge>
        <!-- <b-badge
          v-if="
            ['document-type'].indexOf(filterid) >= 0 &&
            (option.key === 'Product-Specific Guidance' ||
              option.key === 'Archived Guidance')
          "
          variant="success"
          >New</b-badge
        > -->
      </b-form-checkbox>
      <a
        v-show="optionsEndOffset < filteredOptions.length"
        :id="'filter-show-more-' + filterid"
        class="show-more-options"
        @click="showMoreOptions(100)"
        >Show More</a
      >
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: 'CheckboxFilter',
  props: {
    filterid: {
      type: String,
      required: true,
    },
    filtername: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      required: true,
    },
    search: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      optionsEndOffset: 100,
      searchTerm: '',
      showApply: false,
      // need to copy selected by value, otherwise, any change in dataSelected
      // is immediately reflected in parent component
      dataSelected: this.selected.slice(),
    };
  },
  computed: {
    filteredOptions() {
      return this.options.filter(
        (opt) =>
          (opt.key.trim().length > 0 &&
            opt.key.toLowerCase().indexOf(this.searchTerm.toLowerCase()) ===
              0) ||
          (opt.key.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > 0 &&
            opt.key.toLowerCase()[
              // eslint-disable-next-line no-unexpected-multiline
              opt.key.toLowerCase().indexOf(this.searchTerm.toLowerCase()) - 1
            ].match(/[^A-z0-9]/))
      );
    },
    topOptions() {
      return this.filteredOptions.slice(0, this.optionsEndOffset);
    },
  },
  watch: {
    selected() {
      this.dataSelected = this.selected.slice();
    },
    options() {
      const optionKeys = this.options.map((opt) => {
        return opt.key;
      });
      this.dataSelected = this.dataSelected.filter(
        (s) => optionKeys.indexOf(s) !== -1
      );
    },
  },
  beforeCreate() {
    this.optionsEndOffset = 100;
    this.searchTerm = '';
    this.showApply = false;
  },
  methods: {
    emitApplySelections() {
      this.$nextTick(() => {
        this.$emit('apply-selections', this.dataSelected);
        this.showApply = false;
      });
    },
    showMoreOptions(numMoreOptions) {
      this.optionsEndOffset =
        this.optionsEndOffset +
        (numMoreOptions < this.filteredOptions.length
          ? this.optionsEndOffset + numMoreOptions
          : this.filteredOptions.length);
    },
    selectAllOptions() {
      // keep all existing selections
      this.filteredOptions.map((opt) => {
        if (this.dataSelected.indexOf(opt.key) === -1)
          this.dataSelected.push(opt.key);
      });
      this.showApply = true;
    },
    clearAllOptions() {
      this.dataSelected = [];
      this.showApply = true;
    },
  },
};
</script>

<style scoped>
.filter-header {
  font-weight: bold;
}
.checkbox-filter {
  max-height: 30vh;
  width: 95%;
  overflow-y: auto;
}
.show-more-options,
.select-all-options,
.clear-all-options {
  color: blue;
}
.show-more-options:hover,
.select-all-options:hover,
.clear-all-options:hover {
  cursor: pointer;
}
.filter-search {
  height: 2em;
  width: 90%;
}
</style>
